import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "20", height: "5", x: "2", y: "4", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 9v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 13h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Archive";
const Archive = memo(themed(Icon));
export {
  Archive
};
//# sourceMappingURL=archive.js.map
